import React, { FC, KeyboardEvent, useCallback } from "react";

import { isDefined } from "@mapmycustomers/shared/util/assert";
import { NumberField } from "@mapmycustomers/ui";

import EditorComponentProps from "./EditorComponentProps";

export interface NumericEditorProps extends EditorComponentProps<number> {}

const NumericEditor: FC<NumericEditorProps> = ({ duplicate, onChange, onEnter, ...props }) => {
  const handleChange = useCallback(
    (value: number | undefined) => {
      if (isDefined(value)) {
        onChange?.(value);
      }
    },
    [onChange]
  );

  const handleKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === "Enter") {
        onEnter?.();
      }
    },
    [onEnter]
  );

  return (
    <NumberField
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      status={duplicate ? "error" : ""}
      {...props}
    />
  );
};

export default NumericEditor;
